export default __webpack_public_path__ + "static/media/logo.11b0b155.png";